module.exports = __webpack_public_path__ + "static/img/IMG_20160821_132207.816a3e25.jpg";